'use client';

import {createContext, ReactNode, useContext, useEffect, useState} from 'react';

// 1. define Context datatype
interface MenuContextType {
  isShowMenu: boolean;
  isShowMobileMenu: boolean;
  activeMenu: string;
  showMenu: (key: string) => void;
  hideMenu: () => void;
  setIsShowMobileMenu: (value: boolean) => void;
}

// 2. build Context
const MenuContext = createContext<MenuContextType | undefined>(undefined);

// 3. build Provider component
export function MenuProvider({children}: {children: ReactNode}) {
  const [isShowMenu, setIsShowMenu] = useState<boolean>(false);
  const [activeMenu, setActiveMenu] = useState<string>('');
  const [isShowMobileMenu, setIsShowMobileMenu] = useState(false);

  const showMenu = (key: string) => {
    setIsShowMenu(true);
    setActiveMenu(key);
  };

  const hideMenu = () => {
    setIsShowMenu(false);
    setActiveMenu('');
  };

  useEffect(() => {
    if (activeMenu != '') {
      (
        document.querySelector('.menu-section :is(a)') as HTMLElement | null
      )?.focus();
    }
  }, [activeMenu]);

  return (
    <MenuContext.Provider
      value={{
        isShowMenu,
        activeMenu,
        isShowMobileMenu,
        showMenu,
        hideMenu,
        setIsShowMobileMenu
      }}
    >
      {children}
    </MenuContext.Provider>
  );
}

// 4. build useMenu Hoo
export const useMenu = (): MenuContextType => {
  const context = useContext(MenuContext);
  if (context === undefined) {
    throw new Error('useMenu 必須在 MenuProvider 內部使用');
  }
  return context;
};
